import { useCallback, useContext } from 'react';
import classNames from 'classnames';
import TextSearch from 'components/Shared/TextSearch';
import useEvents from 'lib/hooks/useEvents';
import SearchBarTap from 'lib/Tracking/Srp/SearchBarTap';
import SrpEventContext from 'contexts/SrpEventContext';
import styles from './styles';
import LocationFilterCta from '../LocationFilterCta';
import RadiusFilterCta from '../RadiusFilterCta';
import SortByFilterCta from '../SortByFilterCta';

import { useSearchBarModel } from '../useSearchbarModel';

export default function DesktopSearchBar({
  totalCount,
  searchVehicles,
}: {
  totalCount: number;
  searchVehicles: () => Promise<void>;
  isSeo?: boolean;
}): JSX.Element {
  const logger = useEvents();
  const srpEventContext = useContext(SrpEventContext);

  const [value, handleChange] = useSearchBarModel();

  const handleClick = useCallback((): void => {
    logger.log(SearchBarTap({ sourcePage: srpEventContext.sourcePage }));
  }, [logger, srpEventContext.sourcePage]);

  return (
    <>
      <div className={classNames('desktop-text-search-container')}>
        <TextSearch onClick={handleClick} onChange={handleChange} value={value} />
        <LocationFilterCta />
        <RadiusFilterCta />
        <div className="divider" />
        <SortByFilterCta totalCount={totalCount} searchVehicles={searchVehicles} />
      </div>
      <style jsx>{styles}</style>
    </>
  );
}
